<template>
  <div
    ref="item"
    class="p-3 flex border-0 border-b border-solid border-gray-300"
    :class="{ 'bg-gray-200': isPlaying }"
  >
    <a
      @click="play()"
      class="w-8 h-8 mr-3 flex items-center justify-center rounded-full border border-solid border-blue-300 cursor-pointer"
      :class="{
                'bg-white': !isPlaying,
                'bg-blue-300': isPlaying,
            }"
      style="height: 36px"
      title="Play Clip"
    >
      <i
        class="sr-2 sr-v2-play"
        :class="{
                'text-blue-300': !isPlaying,
                'text-white': isPlaying,
            }"
      />
    </a>

    <div class="clip-item-info flex-1 overflow-hidden mt-1 mr-4">
      <div
        class="overflow-hidden ellipsis text-gray-1000"
        :class="{ 'text-blue-300': isPlaying }"
      >{{name}}</div>
      <div
        class="overflow-hidden ellipsis text-gray-900 ds-text-sm italic mt-4"
        v-if="isExpanded && description"
      >{{description}}</div>
    </div>

    <i
      v-if="description"
      class="clip-item-caret sr text-lg text-blue-300 mt-2 cursor-pointer"
      :class="{ [isExpanded ? 'sr-chevron-up' : 'sr-chevron-down']: true }"
      style="justify-self: flex-end"
      @click="onArrowClick()"
    />
  </div>
</template>

<script>
import { mapActions, mapGetters, mapState } from "@/utils/namespaced-mappings";
import DropDownMenu from "@/components/DropDownMenu";
import EditableTitle from "@/components/EditableTitle";
import RatingSelector from "@/components/RatingSelector";
import detectMobile from "@/utils/detectMobileBrowser";

export default {
  props: {
    namespace: { type: String, required: true },
    clipId: { required: true }
  },

  data() {
    return {
      manuallySetExpansionState: null
    };
  },

  computed: {
    ...mapState(["playingClipId", "expandedAllClips"]),
    ...mapGetters(["getClipById"]),

    clip() {
      return this.getClipById(this.clipId);
    },

    isPlaying() {
      return this.playingClipId == this.clipId;
    },

    isExpanded() {
      return this.wasManuallyExpanded
        ? true
        : this.wasManuallyContracted
        ? false
        : this.isPlaying;
    },

    wasManuallyExpanded() {
      return this.manuallySetExpansionState === "expanded";
    },

    wasManuallyContracted() {
      return this.manuallySetExpansionState === "contracted";
    },

    name() {
      return this.clip.name;
    },

    description() {
      return this.clip.description;
    }
  },

  methods: {
    ...mapActions(["jumpToAndPlayClip"]),

    scrollIntoView() {
      const scrollTo = $(this.$refs.item);
      const container = scrollTo.closest(".gradient-scroll");
      const scrollTop =
        scrollTo.offset().top -
        container.offset().top +
        container.scrollTop() -
        container.height() / 2 +
        scrollTo.height();
      container.scrollTop(scrollTop);
    },

    onArrowClick() {
      this.manuallySetExpansionState = this.isExpanded
        ? "contracted"
        : "expanded";
    },

    play() {
      this.jumpToAndPlayClip(this.clipId);

      if (detectMobile("all")) {
        this.scrollToVideo();
      }
    },

    scrollToVideo() {
      const element = $(this.$refs.item)
        .closest(".reel")
        .find(".reel-player")
        .get(0);

      element.scrollIntoView();
    }
  },

  watch: {
    isPlaying(isPlaying, wasPlaying) {
      if (isPlaying && !wasPlaying) {
        this.scrollIntoView();
      }
    },

    expandedAllClips(expandedAllClips) {
      this.manuallySetExpansionState = expandedAllClips
        ? "expanded"
        : "contracted";
    }
  }
};
</script>
